import Offcanvas from 'react-bootstrap/Offcanvas';
import { OffcanvasTitleProps } from 'react-bootstrap';
import { IDrawerStyles, useDrawerStyles } from "..";

export interface DrawerTitleProps extends OffcanvasTitleProps {
    controlStyles?: IDrawerStyles | undefined;
}

const ComponentProps = (props: DrawerTitleProps): OffcanvasTitleProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;

    return componentProps;
}

export const DrawerTitle: React.FC<DrawerTitleProps> = (props) => {
    const styles: IDrawerStyles = props.controlStyles ?? useDrawerStyles();

    return (
        <Offcanvas.Title {...ComponentProps(props)} style={{ ...styles.headerTitle }} />
    );
};